import experiment from 'experiment';
import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import {
  EditorAPIKey,
  EditorCoreApiKey,
  EditorParamsApiKey,
  PanelManagerApiKey,
  ReadonlyModeApiKey,
  WorkspaceApiKey,
  MigrationsManagerApiKey,
} from '#packages/apis';
import { ToursApiKey } from '#packages/editorTours';
import { SectionsMigrationApiKey } from './publicApiKey';
import { SectionsMigrationPublicApi } from './api';
import { initMigration } from './init';
import {
  initPerPageMigration,
  isHomePageMigrated,
  isSiteMigratedByRegularFlow,
} from './initPerPageMigration';
import { createMigrationStatus } from './createMigrationStatus';
import { initSectionsMigrationBanner } from './components/sectionsMigrationBanner/init';
import { MigrationFlow } from './types';

export class SectionsMigrationScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  panelManager = this.useDependency(PanelManagerApiKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  editorParamsAPI = this.useDependency(EditorParamsApiKey);
  tourApi = this.useDependency(ToursApiKey);
  workspaceAPI = this.useDependency(WorkspaceApiKey);
  readonlyModeApi = this.useDependency(ReadonlyModeApiKey);
  migrationManagerApi = this.useDependency(MigrationsManagerApiKey);
  migrationStatus = this.declareApi(createMigrationStatus);
  isSiteMigratedByRegularFlow = this.declareApi(isSiteMigratedByRegularFlow);
}

export const SectionsMigrationEntryPoint = createEntryPoint({
  name: 'SectionsMigration',
  Scope: SectionsMigrationScope,
  publicApi({ contributeApi }) {
    contributeApi(SectionsMigrationApiKey, SectionsMigrationPublicApi);
  },
  async initialize(scope: SectionsMigrationScope) {
    await scope.editorCoreAPI.hooks._dsIsReady.promise;
    const canInitPerPageMigration =
      (experiment.isOpen('se_perPageSectionsMigration') ||
        isHomePageMigrated(scope)) &&
      scope.editorParamsAPI.sectionsMigrationFlow !== MigrationFlow.Template;

    if (canInitPerPageMigration) {
      await initPerPageMigration(scope);
    } else {
      await initMigration(scope);
    }

    initSectionsMigrationBanner(scope);
  },
});
